import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Crewmate from "../components/Crewmate";

const UPDATED  = "25 февраля 2026 г.";
const OPERATOR = "ИП Кузина Татьяна Николаевна";
const EMAIL    = "kuzin.denison@gmail.com";
const SITE     = "neonparty.ru";

const Section = ({ title, children }) => (
  <section style={{ marginBottom: "2rem" }}>
    <div style={{ display: "flex", alignItems: "center", gap: "0.6rem", marginBottom: "0.85rem" }}>
      <div style={{
        background: "#ffe600", border: "2.5px solid #000",
        borderRadius: "0.5rem", boxShadow: "2px 2px 0 #000",
        width: "0.5rem", height: "1.5rem", flexShrink: 0,
      }} />
      <h2 style={{
        fontFamily: "'Fredoka One', sans-serif", fontSize: "1.1rem",
        color: "#ffe600", margin: 0,
      }}>{title}</h2>
    </div>
    <div style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.95rem", color: "#bbb", lineHeight: 1.8 }}>
      {children}
    </div>
  </section>
);

const Li = ({ children }) => (
  <li style={{ marginBottom: "0.4rem", paddingLeft: "0.25rem", listStyle: "none" }}>
    <span style={{ color: "#ffe600", marginRight: "0.4rem" }}>▸</span>{children}
  </li>
);

export default function TermsPage() {
  const navigate = useNavigate();
  return (
    <div className="page-root" style={{ minHeight: "100vh", color: "#fff" }}>
      <Navbar />
      <div style={{ maxWidth: "780px", margin: "0 auto", padding: "3rem 1.5rem 5rem" }}>

        {/* Hero */}
        <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: "1rem" }}>
            <Crewmate color="#ffe600" size={52} animate="bounce" />
          </div>
          <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.8rem", color: "#444", marginBottom: "0.4rem" }}>
            Последнее обновление: {UPDATED}
          </p>
          <h1 style={{
            fontFamily: "'Fredoka One', sans-serif",
            fontSize: "clamp(1.8rem,5vw,2.75rem)",
            color: "#fff", lineHeight: 1.15,
            textShadow: "4px 4px 0 #ffe600, 7px 7px 0 #000",
          }}>Пользовательское соглашение</h1>
        </div>

        {/* Content */}
        <div className="card-cartoon" style={{ padding: "2rem" }}>

          <Section title="1. Предмет соглашения">
            <p>Настоящее Пользовательское соглашение регулирует отношения между пользователем и <strong style={{color:"#fff"}}>{OPERATOR}</strong> при использовании сервиса {SITE}.</p>
            <br/>
            <p>Используя Сервис, вы подтверждаете согласие с условиями Соглашения.</p>
          </Section>

          <Section title="2. Описание сервиса">
            <p>Платформа для многопользовательских вечериночных мини-игр. Один участник — хост с большим экраном, остальные подключаются со своих телефонов.</p>
            <br/>
            <ul style={{ padding: 0 }}>
              <Li>Бесплатные игры — доступны без ограничений.</Li>
              <Li>PRO игры — доступны при наличии действующего кода доступа.</Li>
            </ul>
          </Section>

          <Section title="3. Условия использования">
            <p>Используя Сервис, вы обязуетесь:</p>
            <br/>
            <ul style={{ padding: 0 }}>
              <Li>Не использовать Сервис в противоправных целях.</Li>
              <Li>Не нарушать работу Сервиса (DDoS, перебор кодов, автоматические запросы).</Li>
              <Li>Не копировать и не распространять контент Сервиса без разрешения Оператора.</Li>
              <Li>Использовать никнеймы без оскорблений и незаконного контента.</Li>
              <Li>Не перепродавать коды доступа PRO третьим лицам.</Li>
            </ul>
          </Section>

          <Section title="4. PRO доступ и оплата">
            <p>PRO игры доступны по кодам доступа с ограниченным количеством использований.</p>
            <br/>
            <ul style={{ padding: 0 }}>
              <Li>Код активируется в браузере и сохраняется локально.</Li>
              <Li>Одно использование = одна созданная игровая комната.</Li>
              <Li>Использованные комнаты возврату не подлежат.</Li>
            </ul>
            <br/>
            <p><strong style={{color:"#ff3355"}}>Возвраты:</strong> Неиспользованный остаток подлежит возврату в течение 14 дней с момента покупки при обращении на <strong style={{color:"#ffe600"}}>{EMAIL}</strong>.</p>
          </Section>

          <Section title="5. Возрастные ограничения">
            <p>Сервис предназначен для лиц старше 12 лет. Игры «18+» — только для совершеннолетних.</p>
          </Section>

          <Section title="6. Интеллектуальная собственность">
            <p>Все права на Сервис, дизайн, программный код и контент принадлежат Оператору. Пользователю предоставляется ограниченная лицензия на использование в личных некоммерческих целях.</p>
          </Section>

          <Section title="7. Ограничение ответственности">
            <p>Сервис предоставляется «как есть». Оператор не несёт ответственности за:</p>
            <br/>
            <ul style={{ padding: 0 }}>
              <Li>Временную недоступность по техническим причинам.</Li>
              <Li>Действия третьих лиц, нарушающих работу Сервиса.</Li>
              <Li>Потерю игрового прогресса вследствие технических сбоев.</Li>
            </ul>
          </Section>

          <Section title="8. Запрещённый контент">
            <p>Запрещено размещать контент, который пропагандирует насилие, экстремизм, содержит материалы сексуального насилия над несовершеннолетними, оскорбляет честь и достоинство граждан.</p>
          </Section>

          <Section title="9. Применимое право">
            <p>Соглашение регулируется законодательством Российской Федерации. Споры разрешаются по месту нахождения Оператора.</p>
          </Section>

          <Section title="10. Изменения Соглашения">
            <p>Актуальная редакция всегда на этой странице. Продолжение использования Сервиса означает согласие с новой редакцией.</p>
          </Section>

          <Section title="11. Контакты">
            <p>По вопросам Соглашения: <strong style={{color:"#ffe600"}}>{EMAIL}</strong></p>
          </Section>

          {/* Footer */}
          <div style={{
            marginTop: "2rem", padding: "1rem 1.25rem",
            background: "#0d0820", border: "2px solid #000",
            borderRadius: "0.75rem", boxShadow: "2px 2px 0 #000",
            fontFamily: "'Nunito', sans-serif", fontSize: "0.78rem", color: "#444",
            textAlign: "center",
          }}>
            {OPERATOR} · ИНН 401900080185 · ОГРНИП 322402700054046 · {SITE}
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <button onClick={() => navigate("/")} className="btn-cartoon btn-accent" style={{ padding: "0.6rem 1.5rem" }}>
            ← На главную
          </button>
        </div>

      </div>
    </div>
  );
}